import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Modal } from "antd";
import { assignMessage, convertRoundNumber, errorMessage, successMessage } from '../../../utils/helpers'
import { ADMIN } from '../../../utils/apis'
import axios from "axios";
import { currencySign } from "../../../utils/constants";

const OrganizePayCostSetting = (props) => {
    const { user, language, selectedLanguage } = props
    const [visible, setVisible] = useState(false)
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [tournamentOrganizerPayCost, setTournamentOrganizerPayCost] = useState(null)

    const gettournamentOrganizerPayCost = () => {
        axios.get(ADMIN?.GET_TOURNAMENT_ORGANIZER_PAY_COST_POINT)
            .then((res) => {
                const { data } = res
                setTournamentOrganizerPayCost(data?.data?.[0] || [])
            })
            .catch((e) => {
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }


    const onFinish = (values) => {
        values.adminId = user?._id
        tournamentOrganizerPayCost?.money && (values._id = tournamentOrganizerPayCost?._id)
        axios.post(tournamentOrganizerPayCost?._id ? ADMIN?.EDIT_TOURNAMENT_ORGANIZER_PAY_COST_POINT : ADMIN?.ADD_TOURNAMENT_ORGANIZER_PAY_COST_POINT, values)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    successMessage(assignMessage(data?.message, language?.language))
                    gettournamentOrganizerPayCost()
                }
            })
            .catch((e) => {
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }

    useEffect(() => {
        gettournamentOrganizerPayCost()
    }, [])

    const handleOk = () => {
        setVisible(false)
    }


    return (
        <>
            <div className="reward-point-box">
                <p className="p-none-margin-bolder-p">{selectedLanguage?.text_WhenPlayerOrganizeTournamemtHeMustPayACost}</p>
                <p className="p-none-margin-bolder-p">
                    {selectedLanguage?.text_playercanpay} ( {tournamentOrganizerPayCost?.money ? `${currencySign} ${convertRoundNumber(tournamentOrganizerPayCost?.money)}` : '---'} )
                    {selectedLanguage?.text_fororganizetournamentasservicefee}</p>
                <div style={{ marginTop: '20px' }} className='button-div-flex-end'>
                    <Button
                        type="primary"
                        onClick={() => { setVisible(true) }} > {selectedLanguage?.text_Updattournamentorganizecost}</Button>
                </div>
            </div >
            {/* --------Modal----- */}

            < Modal
                open={visible}
                onOk={handleOk}
                onCancel={handleOk} className='pop-info-modal'
                footer={null}>

                <div style={{ marginTop: '10px' }}>
                    <p className='p-question'>{selectedLanguage?.text_Updatetournamentorganizepaycost}</p>
                    <div style={{ display: 'flex', flexDirection: 'column' }} className='form-div-in-modal'>
                        <Form
                            name='form'
                            form={form}
                            onFinish={onFinish}
                            layout={'vertical'}
                        >
                            <div className='form-two-input-flex-inner-input newInpuHeightFull' style={{ width: '100%' }}>
                                <Form.Item
                                    name='money'
                                    initialValue={tournamentOrganizerPayCost?.money}
                                    hasFeedback
                                    label={<p className='p-admin-title-text'>{selectedLanguage?.text_Tournamentorganizerpaycost}</p>}
                                    rules={[
                                        {
                                            required: true,
                                            message: selectedLanguage?.text_pleaseentertournamentorganizerpaycost
                                        }
                                    ]}
                                >
                                    <Input
                                        // Number
                                        step={0.5}    // Set the step to 0.01 for two decimal places
                                        precision={2}
                                        type='number'
                                        style={{ width: '100%' }}
                                        className='form-input-new-design-big-slam'
                                        prefix={<p style={{ color: 'white', margin: '0px' }}>{currencySign}</p>}
                                        placeholder={selectedLanguage?.text_Entertournamentorganizerpaycosthere}
                                    />
                                </Form.Item>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', height: '40px', paddingRight: '5px' }}>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType='submit'
                                        loading={loading}
                                    >
                                        {tournamentOrganizerPayCost?.money ? selectedLanguage?.text_UpdatePointSetting : selectedLanguage?.text_AddPointSetting}
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </div>
                </div >
            </Modal >
        </>
    )
}



export default OrganizePayCostSetting